import { Component, OnDestroy, OnInit } from '@angular/core';

/**
 * Muestra Pagina para el error 404 (No encontrada)
 */
@Component( {
  selector: 'app-pagina-no-encontrada',
  templateUrl: 'paginaNoEncontrada.component.html',
} )
export class PaginaNoEncontradaComponent implements OnInit, OnDestroy {

  /**
   * Función de Inicio de la funcionalidad llamado despues del contructor
   */
  ngOnInit(): void {
    $( 'body' ).addClass( 'page-no-found' );
  }

  /**
   * Función que se ejecuta al salir de la funcionalidad
   */
  ngOnDestroy() {
    $( 'body' ).removeClass( 'page-no-found' );
  }
}
